export default {"src":"/_next/static/media/m3.c51b3f78.svg","height":154,"width":100,"blurWidth":0,"blurHeight":0};